/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Hamza Naseer",
  title: "Hi all, I'm Hamza",
  subTitle: emoji(
    "A dedicated and enthusiastic Data Scientist 🚀 with a strong foundation in Machine Learning and a flair for building innovative solutions. My expertise revolves around utilizing advanced algorithms, Python, and libraries like TensorFlow and PyTorch to derive valuable insights and create impactful data-driven applications. I am passionate about exploring the vast potential of AI and eager to contribute my skills in shaping the future of data science."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1QIWy94rVRhQ3EY7bza1r5NEm2iIOZjaD/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/umegs",
  linkedin: "https://www.linkedin.com/in/umegs-hamza",
  gmail: "umegs.hamza@gmail.com",
  kaggle: "https://www.kaggle.com/umegshamza",
  phone: "+923058731372",
  // gitlab: "https://gitlab.com/saadpasta",
  // facebook: "https://www.facebook.com/saad.pasta7",
  // medium: "https://medium.com/@saadpasta",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section


const skillsSection = {
  title: "What I do",
  subTitle: "PASSIONATE DATA SCIENTIST AND MACHINE LEARNING ENTHUSIAST",
  skills: [
    emoji(
      "⚡ Develop and deploy end-to-end Machine Learning models for diverse applications"
    ),
    emoji(
      "⚡ Utilize advanced algorithms and data visualization techniques to derive valuable insights"
    ),
    emoji(
      "⚡ Integrate and manage data pipelines, databases, and cloud services for data-driven applications"
    ),
    emoji(
      "⚡ Implement Natural Language Processing (NLP) and Computer Vision algorithms for AI-driven solutions"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
  https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "PHP",
      fontAwesomeClassname: "fab fa-php"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "Laravel",
      fontAwesomeClassname: "fab fa-laravel"
    },
    {
      skillName: "NodeJS",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "ReactJS",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "javascript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "pytorch",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "tensorflow",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "numpy",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "pandas",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "scikit-learn",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "matplotlib",
      fontAwesomeClassname: "fab fa-python"
    },

  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "GIFT University",
      logo: require("./assets/images/gift_logo.png"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "September 2016 - September 2020",
      desc: "Achieved academic excellence, with a focus on Software Engineering, Data Science, and Machine Learning. Coursework included in-depth study of algorithms, data structures, and database management.",
      descBullets: [
        "Developed proficiency in Python, Java, and JavaScript for software development.",
        "Applied statistical methods and data analysis techniques to solve complex problems.",
        "Completed projects on Data Visualization, Machine Learning, and Natural Language Processing.",
        "Collaborated on team-based projects to design and implement web applications."
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience
const techStack = {
  viewSkillBars: true, // Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Machine Learning", // Insert stack or technology you have experience in
      progressPercentage: "90%" // Insert relative proficiency in percentage
    },
    {
      Stack: "Data Science",
      progressPercentage: "85%"
    },
    {
      Stack: "Python Programming",
      progressPercentage: "80%"
    },
    {
      Stack: "Natural Language Processing (NLP)",
      progressPercentage: "75%"
    },
    {
      Stack: "Deep Learning",
      progressPercentage: "70%"
    },
    {
      Stack: "Flask",
      progressPercentage: "95%"
    },
    {
      Stack: "Django",
      progressPercentage: "85%"
    },
    {
      Stack: "Node.js",
      progressPercentage: "80%"
    },
    {
      Stack: "PHP",
      progressPercentage: "90%"
    },
    {
      Stack: "Java",
      progressPercentage: "90%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};


// Work experience section
const workExperiences = {
  display: true, // Set it to true to show workExperiences Section
  experience: [
    {
      role: "Data Scientist",
      company: "Nextbridge Ltd.",
      companylogo: require("./assets/images/nextbridgeLogo.png"),
      date: "September 2022 – Present",
      desc: "Contributed to cutting-edge projects in diverse domains, such as real-time damage detection, scoliosis assessment, and employee monitoring using Python, TensorFlow, and PyTorch.",
      descBullets: [
        "Developed deep learning-based solutions for real-world challenges.",
        "Led landmark detection system development for precise scoliosis assessment.",
        "Implemented face recognition technology to enhance workplace safety and productivity."
      ]
    },
    {
      role: "Python Developer and Associate Data Scientist",
      company: "Babyplanet.pk",
      companylogo: require("./assets/images/babyplanetLogo.png"),
      date: "January 2021 – August 2022",
      desc: "Contributed as both a Python Developer and Associate Data Scientist. Developed web apps in Django for order processing and completed a custom ERP system integrated with multiple courier services. Implemented association rule mining for personalized product recommendations.",
      descBullets: [
        "Designed and developed web apps using Django and ReactJS.",
        "Integrated multiple courier services for efficient order booking.",
        "Implemented association rule mining for personalized product recommendations."
      ]
    },
    {
      role: "Web Developer",
      company: "Hixol",
      companylogo: require("./assets/images/hixolLogo.png"),
      date: "May 2020 – January 2021",
      desc: "Developed innovative online shopping stores and a free fundraising service for nonprofits using PHP, Laravel, and CodeIgniter. Provided seamless user experiences and efficient shopping interfaces.",
      descBullets: [
        "Created online shopping stores using CodeIgniter and Laravel.",
        "Developed a free fundraising service for nonprofits using Laravel and ReactJS.",
        "Ensured smooth and efficient shopping experiences for users."
      ]
    },
    {
      role: "Software Engineering Trainee",
      company: "Stewart Pakistan Private Limited",
      companylogo: require("./assets/images/stewartLogo.png"),
      date: "September 2018 – November 2018",
      desc: "Internship involvement in developing Employee Monitoring System, including desktop and web applications, face recognition technology integration, and location tracking.",
      descBullets: [
        "Developed desktop application for displaying important notes for employees.",
        "Worked on a web application for employee data retrieval and monitoring.",
        "Integrated face recognition technology with CCTV cameras for real-time employee tracking."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc
const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
      "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Huawei AI Certification",
      subtitle:
          "Certified in Huawei AI course, enhancing my expertise in Artificial Intelligence.",
      image: require("./assets/images/huaweiAILogo.png"),
      imageAlt: "Huawei AI Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1zlqCOV-ujlKV4Y4e62U74sTnNUyWOaGd/view?usp=sharing"
        }
      ]
    },
    {
      title: "Azure AI Fundamentals Certification",
      subtitle:
          "Completed Azure AI Fundamentals course, strengthening my knowledge in AI technologies on Microsoft Azure platform.",
      image: require("./assets/images/azureAILogo.png"),
      imageAlt: "Azure AI Fundamentals Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1g7zrdJbw-UEYRrIap3BKbUGuqTNfyFu7/view?usp=sharing"
        }
      ]
    },
    {
      title: "GIFT UNIVERSITY 1st Position",
      subtitle:
          "Secured 1st Position in the BSCS program at GIFT University, reflecting academic excellence.",
      image: require("./assets/images/giftLogo_certification.png"),
      imageAlt: "GIFT University Logo",
      footerLink: [
        {
          name: "Certificate",
          url: "https://drive.google.com/file/d/1BxaEnmTd-cf--VJGpSRW4hCOoU5gSgep/view?usp=sharing"
        }
      ]
    },
    {
      title: "NAVTTC AI Course Certification",
      subtitle:
          "Completed NAVTTC AI Course, expanding my knowledge in the field of Artificial Intelligence.",
      image: require("./assets/images/navttcLogo.png"),
      imageAlt: "NAVTTC Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1cT_I5jHy13k-i-dR9tWQhugwYo6EXlI7/view?usp=sharing"
        }
      ]
    },
    {
      title: "Space App Challenge",
      subtitle:
          "Participated in the Space App Challenge, showcasing innovation and problem-solving abilities.",
      image: require("./assets/images/spaceAppLogo.png"),
      imageAlt: "Space App Challenge Logo",
      footerLink: [
        {
          name: "Certificate",
          url: "https://drive.google.com/file/d/1T-i3m12ym2CRUq65NzNN2q9lhBHuxHy-/view?usp=sharing"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};


// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+92-3058731372",
  email_address: "umegs.hamza@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
